const supportedLngs = [
  'en',
  'de',
  'nl',
  'fr',
  'ja',
  'ko',
  'pt',
  'zh',
  'es',
  'ru',
  'ar',
  'it',
  'tr',
  'hi',
  'sv',
  'nb',
  'fi',
  'pl',
  'da',
  'vi',
];

const namespaces = [
  'account',
  'alert_feedback',
  'alerts',
  'analytics',
  'api',
  'article',
  'assistant',
  'articles',
  'batch_registration',
  'billing',
  'binder',
  'binders',
  'categories',
  'common',
  'companies',
  'company',
  'compliance',
  'countries',
  'dashboard',
  'directors',
  'feedback',
  'groups',
  'industries',
  'invitations',
  'languages',
  'login',
  'menu',
  'notes',
  'password_reset',
  'permissions',
  'portfolio',
  'portfolios',
  'regions',
  'reports',
  'reviews',
  'ubo',
];

const defaultLocale = 'en';
const fallbackLanguage = 'en';
const defaultNamespace = 'common';

module.exports = {
  supportedLngs,
  namespaces,
  defaultLocale,
  fallbackLanguage,
  defaultNamespace,
};
